import { QueryFilter } from "src/app/shared/models/query-filter.model";

export class MembershipCustomerListQueryFilter extends QueryFilter {
  public organizationId: string;
} 